/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type {
  AIInstructionDTO,
  AIInstructionIgnoreDTO,
  AIInstructionWriteDTO,
  HTTPValidationError,
  ProjectAIInstructionsDTO,
} from '../fastAPI.schemas'

/**
 * The organisation's AI instructions, oldest first.
 * @summary Get Organisation Ai Instructions
 */
export const getOrganisationAiInstructions = (signal?: AbortSignal) => {
  return customInstance<AIInstructionDTO[]>({
    url: `/my-organisation/ai-instructions`,
    method: 'GET',
    signal,
  })
}

export const getGetOrganisationAiInstructionsQueryKey = () => {
  return [`/my-organisation/ai-instructions`] as const
}

export const getGetOrganisationAiInstructionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganisationAiInstructions>>,
  TError = HTTPValidationError,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getOrganisationAiInstructions>>, TError, TData>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOrganisationAiInstructionsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganisationAiInstructions>>> = ({
    signal,
  }) => getOrganisationAiInstructions(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganisationAiInstructions>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetOrganisationAiInstructionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganisationAiInstructions>>
>
export type GetOrganisationAiInstructionsQueryError = HTTPValidationError

/**
 * @summary Get Organisation Ai Instructions
 */

export function useGetOrganisationAiInstructions<
  TData = Awaited<ReturnType<typeof getOrganisationAiInstructions>>,
  TError = HTTPValidationError,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getOrganisationAiInstructions>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrganisationAiInstructionsQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Add an AI instruction for the whole organisation (admins only).

Applies to every project of the organisation that does not ignore it,
including existing ones -- nothing is copied into projects.
 * @summary Create Organisation Ai Instruction
 */
export const createOrganisationAiInstruction = (
  aIInstructionWriteDTO: AIInstructionWriteDTO,
  signal?: AbortSignal,
) => {
  return customInstance<AIInstructionDTO>({
    url: `/my-organisation/ai-instructions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: aIInstructionWriteDTO,
    signal,
  })
}

export const useCreateOrganisationAiInstructionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrganisationAiInstruction>>,
    TError,
    { data: AIInstructionWriteDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrganisationAiInstruction>>,
  TError,
  { data: AIInstructionWriteDTO },
  TContext
> => {
  const mutationKey = ['createOrganisationAiInstruction']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrganisationAiInstruction>>,
    { data: AIInstructionWriteDTO }
  > = props => {
    const { data } = props ?? {}

    return createOrganisationAiInstruction(data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/my-organisation/ai-instructions` },
    {
      operationId: 'create_organisation_ai_instruction_my_organisation_ai_instructions_post',
      operationName: 'createOrganisationAiInstruction',
    },
  )

  return customOptions
}

export type CreateOrganisationAiInstructionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrganisationAiInstruction>>
>
export type CreateOrganisationAiInstructionMutationBody = AIInstructionWriteDTO
export type CreateOrganisationAiInstructionMutationError = HTTPValidationError

/**
 * @summary Create Organisation Ai Instruction
 */
export const useCreateOrganisationAiInstruction = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrganisationAiInstruction>>,
    TError,
    { data: AIInstructionWriteDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof createOrganisationAiInstruction>>,
  TError,
  { data: AIInstructionWriteDTO },
  TContext
> => {
  const mutationOptions = useCreateOrganisationAiInstructionMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Delete one organisation AI instruction (admins only).
 * @summary Delete Organisation Ai Instruction
 */
export const deleteOrganisationAiInstruction = (instructionId: string) => {
  return customInstance<unknown>({
    url: `/my-organisation/ai-instructions/${instructionId}`,
    method: 'DELETE',
  })
}

export const useDeleteOrganisationAiInstructionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrganisationAiInstruction>>,
    TError,
    { instructionId: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOrganisationAiInstruction>>,
  TError,
  { instructionId: string },
  TContext
> => {
  const mutationKey = ['deleteOrganisationAiInstruction']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOrganisationAiInstruction>>,
    { instructionId: string }
  > = props => {
    const { instructionId } = props ?? {}

    return deleteOrganisationAiInstruction(instructionId)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/my-organisation/ai-instructions/{instructionId}` },
    {
      operationId:
        'delete_organisation_ai_instruction_my_organisation_ai_instructions__instruction_id__delete',
      operationName: 'deleteOrganisationAiInstruction',
    },
  )

  return customOptions
}

export type DeleteOrganisationAiInstructionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOrganisationAiInstruction>>
>

export type DeleteOrganisationAiInstructionMutationError = HTTPValidationError

/**
 * @summary Delete Organisation Ai Instruction
 */
export const useDeleteOrganisationAiInstruction = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrganisationAiInstruction>>,
    TError,
    { instructionId: string },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteOrganisationAiInstruction>>,
  TError,
  { instructionId: string },
  TContext
> => {
  const mutationOptions = useDeleteOrganisationAiInstructionMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Replace the text of one organisation AI instruction (admins only).
 * @summary Update Organisation Ai Instruction
 */
export const updateOrganisationAiInstruction = (
  instructionId: string,
  aIInstructionWriteDTO: AIInstructionWriteDTO,
) => {
  return customInstance<AIInstructionDTO>({
    url: `/my-organisation/ai-instructions/${instructionId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: aIInstructionWriteDTO,
  })
}

export const useUpdateOrganisationAiInstructionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganisationAiInstruction>>,
    TError,
    { instructionId: string; data: AIInstructionWriteDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrganisationAiInstruction>>,
  TError,
  { instructionId: string; data: AIInstructionWriteDTO },
  TContext
> => {
  const mutationKey = ['updateOrganisationAiInstruction']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrganisationAiInstruction>>,
    { instructionId: string; data: AIInstructionWriteDTO }
  > = props => {
    const { instructionId, data } = props ?? {}

    return updateOrganisationAiInstruction(instructionId, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/my-organisation/ai-instructions/{instructionId}` },
    {
      operationId:
        'update_organisation_ai_instruction_my_organisation_ai_instructions__instruction_id__put',
      operationName: 'updateOrganisationAiInstruction',
    },
  )

  return customOptions
}

export type UpdateOrganisationAiInstructionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrganisationAiInstruction>>
>
export type UpdateOrganisationAiInstructionMutationBody = AIInstructionWriteDTO
export type UpdateOrganisationAiInstructionMutationError = HTTPValidationError

/**
 * @summary Update Organisation Ai Instruction
 */
export const useUpdateOrganisationAiInstruction = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganisationAiInstruction>>,
    TError,
    { instructionId: string; data: AIInstructionWriteDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof updateOrganisationAiInstruction>>,
  TError,
  { instructionId: string; data: AIInstructionWriteDTO },
  TContext
> => {
  const mutationOptions = useUpdateOrganisationAiInstructionMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * The AI instructions for this project: its own and its organisation's.

In effect are all ``project_instructions`` plus every organisation
instruction that is not ``ignored``.
 * @summary Get Project Ai Instructions
 */
export const getProjectAiInstructions = (projectGuid: string, signal?: AbortSignal) => {
  return customInstance<ProjectAIInstructionsDTO>({
    url: `/projects/${projectGuid}/ai-instructions`,
    method: 'GET',
    signal,
  })
}

export const getGetProjectAiInstructionsQueryKey = (projectGuid?: string) => {
  return [`/projects/${projectGuid}/ai-instructions`] as const
}

export const getGetProjectAiInstructionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectAiInstructions>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getProjectAiInstructions>>, TError, TData>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetProjectAiInstructionsQueryKey(projectGuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectAiInstructions>>> = ({
    signal,
  }) => getProjectAiInstructions(projectGuid, signal)

  return { queryKey, queryFn, enabled: !!projectGuid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectAiInstructions>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetProjectAiInstructionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectAiInstructions>>
>
export type GetProjectAiInstructionsQueryError = HTTPValidationError

/**
 * @summary Get Project Ai Instructions
 */

export function useGetProjectAiInstructions<
  TData = Awaited<ReturnType<typeof getProjectAiInstructions>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getProjectAiInstructions>>, TError, TData>
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProjectAiInstructionsQueryOptions(projectGuid, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Add an AI instruction that applies to this project only.
 * @summary Create Project Ai Instruction
 */
export const createProjectAiInstruction = (
  projectGuid: string,
  aIInstructionWriteDTO: AIInstructionWriteDTO,
  signal?: AbortSignal,
) => {
  return customInstance<AIInstructionDTO>({
    url: `/projects/${projectGuid}/ai-instructions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: aIInstructionWriteDTO,
    signal,
  })
}

export const useCreateProjectAiInstructionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProjectAiInstruction>>,
    TError,
    { projectGuid: string; data: AIInstructionWriteDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProjectAiInstruction>>,
  TError,
  { projectGuid: string; data: AIInstructionWriteDTO },
  TContext
> => {
  const mutationKey = ['createProjectAiInstruction']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProjectAiInstruction>>,
    { projectGuid: string; data: AIInstructionWriteDTO }
  > = props => {
    const { projectGuid, data } = props ?? {}

    return createProjectAiInstruction(projectGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/ai-instructions` },
    {
      operationId: 'create_project_ai_instruction_projects__project_guid__ai_instructions_post',
      operationName: 'createProjectAiInstruction',
    },
  )

  return customOptions
}

export type CreateProjectAiInstructionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProjectAiInstruction>>
>
export type CreateProjectAiInstructionMutationBody = AIInstructionWriteDTO
export type CreateProjectAiInstructionMutationError = HTTPValidationError

/**
 * @summary Create Project Ai Instruction
 */
export const useCreateProjectAiInstruction = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProjectAiInstruction>>,
    TError,
    { projectGuid: string; data: AIInstructionWriteDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof createProjectAiInstruction>>,
  TError,
  { projectGuid: string; data: AIInstructionWriteDTO },
  TContext
> => {
  const mutationOptions = useCreateProjectAiInstructionMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Ignore (or apply again) one organisation instruction in this project.

Does not change the organisation instruction itself or other projects.
 * @summary Set Project Organisation Ai Instruction Ignored
 */
export const setProjectOrganisationAiInstructionIgnored = (
  projectGuid: string,
  instructionId: string,
  aIInstructionIgnoreDTO: AIInstructionIgnoreDTO,
) => {
  return customInstance<ProjectAIInstructionsDTO>({
    url: `/projects/${projectGuid}/ai-instructions/organisation/${instructionId}/ignored`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: aIInstructionIgnoreDTO,
  })
}

export const useSetProjectOrganisationAiInstructionIgnoredMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setProjectOrganisationAiInstructionIgnored>>,
    TError,
    { projectGuid: string; instructionId: string; data: AIInstructionIgnoreDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof setProjectOrganisationAiInstructionIgnored>>,
  TError,
  { projectGuid: string; instructionId: string; data: AIInstructionIgnoreDTO },
  TContext
> => {
  const mutationKey = ['setProjectOrganisationAiInstructionIgnored']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setProjectOrganisationAiInstructionIgnored>>,
    { projectGuid: string; instructionId: string; data: AIInstructionIgnoreDTO }
  > = props => {
    const { projectGuid, instructionId, data } = props ?? {}

    return setProjectOrganisationAiInstructionIgnored(projectGuid, instructionId, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/ai-instructions/organisation/{instructionId}/ignored` },
    {
      operationId:
        'set_project_organisation_ai_instruction_ignored_projects__project_guid__ai_instructions_organisation__instruction_id__ignored_put',
      operationName: 'setProjectOrganisationAiInstructionIgnored',
    },
  )

  return customOptions
}

export type SetProjectOrganisationAiInstructionIgnoredMutationResult = NonNullable<
  Awaited<ReturnType<typeof setProjectOrganisationAiInstructionIgnored>>
>
export type SetProjectOrganisationAiInstructionIgnoredMutationBody = AIInstructionIgnoreDTO
export type SetProjectOrganisationAiInstructionIgnoredMutationError = HTTPValidationError

/**
 * @summary Set Project Organisation Ai Instruction Ignored
 */
export const useSetProjectOrganisationAiInstructionIgnored = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setProjectOrganisationAiInstructionIgnored>>,
    TError,
    { projectGuid: string; instructionId: string; data: AIInstructionIgnoreDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof setProjectOrganisationAiInstructionIgnored>>,
  TError,
  { projectGuid: string; instructionId: string; data: AIInstructionIgnoreDTO },
  TContext
> => {
  const mutationOptions = useSetProjectOrganisationAiInstructionIgnoredMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Delete one of this project's AI instructions.
 * @summary Delete Project Ai Instruction
 */
export const deleteProjectAiInstruction = (projectGuid: string, instructionId: string) => {
  return customInstance<unknown>({
    url: `/projects/${projectGuid}/ai-instructions/${instructionId}`,
    method: 'DELETE',
  })
}

export const useDeleteProjectAiInstructionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProjectAiInstruction>>,
    TError,
    { projectGuid: string; instructionId: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProjectAiInstruction>>,
  TError,
  { projectGuid: string; instructionId: string },
  TContext
> => {
  const mutationKey = ['deleteProjectAiInstruction']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProjectAiInstruction>>,
    { projectGuid: string; instructionId: string }
  > = props => {
    const { projectGuid, instructionId } = props ?? {}

    return deleteProjectAiInstruction(projectGuid, instructionId)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/ai-instructions/{instructionId}` },
    {
      operationId:
        'delete_project_ai_instruction_projects__project_guid__ai_instructions__instruction_id__delete',
      operationName: 'deleteProjectAiInstruction',
    },
  )

  return customOptions
}

export type DeleteProjectAiInstructionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProjectAiInstruction>>
>

export type DeleteProjectAiInstructionMutationError = HTTPValidationError

/**
 * @summary Delete Project Ai Instruction
 */
export const useDeleteProjectAiInstruction = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProjectAiInstruction>>,
    TError,
    { projectGuid: string; instructionId: string },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteProjectAiInstruction>>,
  TError,
  { projectGuid: string; instructionId: string },
  TContext
> => {
  const mutationOptions = useDeleteProjectAiInstructionMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Replace the text of one of this project's AI instructions.
 * @summary Update Project Ai Instruction
 */
export const updateProjectAiInstruction = (
  projectGuid: string,
  instructionId: string,
  aIInstructionWriteDTO: AIInstructionWriteDTO,
) => {
  return customInstance<AIInstructionDTO>({
    url: `/projects/${projectGuid}/ai-instructions/${instructionId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: aIInstructionWriteDTO,
  })
}

export const useUpdateProjectAiInstructionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProjectAiInstruction>>,
    TError,
    { projectGuid: string; instructionId: string; data: AIInstructionWriteDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProjectAiInstruction>>,
  TError,
  { projectGuid: string; instructionId: string; data: AIInstructionWriteDTO },
  TContext
> => {
  const mutationKey = ['updateProjectAiInstruction']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProjectAiInstruction>>,
    { projectGuid: string; instructionId: string; data: AIInstructionWriteDTO }
  > = props => {
    const { projectGuid, instructionId, data } = props ?? {}

    return updateProjectAiInstruction(projectGuid, instructionId, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/ai-instructions/{instructionId}` },
    {
      operationId:
        'update_project_ai_instruction_projects__project_guid__ai_instructions__instruction_id__put',
      operationName: 'updateProjectAiInstruction',
    },
  )

  return customOptions
}

export type UpdateProjectAiInstructionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProjectAiInstruction>>
>
export type UpdateProjectAiInstructionMutationBody = AIInstructionWriteDTO
export type UpdateProjectAiInstructionMutationError = HTTPValidationError

/**
 * @summary Update Project Ai Instruction
 */
export const useUpdateProjectAiInstruction = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProjectAiInstruction>>,
    TError,
    { projectGuid: string; instructionId: string; data: AIInstructionWriteDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProjectAiInstruction>>,
  TError,
  { projectGuid: string; instructionId: string; data: AIInstructionWriteDTO },
  TContext
> => {
  const mutationOptions = useUpdateProjectAiInstructionMutationOptions(options)

  return useMutation(mutationOptions)
}
